export default __webpack_public_path__ + "static/media/laptop.2fc65945.webp";